import { useLocation, useNavigate, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import Header from "@/components/marketing/Header";
import Footer from "@/components/marketing/Footer";
import SEO from "@/components/marketing/SEO";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      <SEO
        title="Page introuvable - 404"
        description="La page que vous recherchez n'existe pas ou a été déplacée."
        canonical="/"
      />
      <Header />
      <main className="flex-1 flex items-center justify-center pt-16 px-4">
        <div className="text-center max-w-2xl space-y-8">
          <div className="space-y-4">
            <h1 className="font-playfair text-6xl md:text-7xl font-bold text-foreground">
              404
            </h1>
            <h2 className="text-2xl md:text-3xl font-semibold text-foreground">
              Page introuvable
            </h2>
            <p className="text-lg text-muted-foreground">
              Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
            </p>
          </div>

          <div className="flex justify-center">
            <Button size="lg" onClick={() => navigate("/")}>
              Retour à l'accueil
            </Button>
          </div>

          <div className="pt-8 border-t border-border">
            <p className="text-muted-foreground mb-4">
              Vous cherchez peut-être :
            </p>
            <div className="flex flex-wrap gap-3 justify-center">
              <Link to="/lausanne" className="text-primary hover:underline">
                Piktable à Lausanne
              </Link>
              <span className="text-muted-foreground">•</span>
              <Link to="/geneve" className="text-primary hover:underline">
                Piktable à Genève
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
